module.exports = __webpack_public_path__ + "2f01b90381e43cd3f8f9c1328fa53334.png";